// extracted by mini-css-extract-plugin
export default {"root":"Saml_root__qYIEl","wrapper":"Saml_wrapper__6fDCm","container":"Saml_container__jdR9g"};